import React, { useEffect, useState } from 'react';
import { CardSection } from '../../shared/components/card/CardSection';
import {
  useCallAction,
  useEvent,
  useStore,
} from '@cobuildlab/react-simple-state';

import { Typography, Box, Stack } from '@mui/material';
import { fetchPlanList } from './plan-actions';
import { PlansTable } from './components/PlansTable';
import { planListEvent } from './plan-events';
import { PlanTableFilter } from './components/PlanTableFilter';
import { plansFilterStore } from './plan-store';

export const PlansView: React.FC = () => {
  const { data, total } = useEvent(planListEvent);
  const filter = useStore(plansFilterStore);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    page: 1,
  });

  const [callAction, loading] = useCallAction(fetchPlanList, {
    onCompleted: () => {
      // console.log(data);
    },
    onError: (error) => {
      console.log({ error });
    },
  });

  useEffect(() => {
      callAction({
        page: pagination.page,
        pageSize: pagination.pageSize,
        status: filter.status,
        isPremium: filter.isPremium,
      });

  }, [callAction, pagination, filter]);

  return (
    <CardSection
      title={
        <Stack
          direction={'row'}
          width={'100%'}
          alignItems={'center'}
          justifyContent={'space-between'}
          sx={{ py: '15px' }}>
          <Box>
            <Typography fontSize={{ sx: '16px', md: '20px' }} fontWeight={600}>
              Planes
            </Typography>
          </Box>
          <PlanTableFilter />
        </Stack>
      }>
      <PlansTable
        data={data}
        loading={loading}
        total={total}
        pagination={pagination}
        hanChangePagination={(newPagination) => setPagination(newPagination)}
      />
    </CardSection>
  );
};
